import axios from "axios";

export default {
  pages(locale) {
    return axios.post("/api/query", {
      query: "site.children.listed",
      select: {
        title: `page.content('${locale}').title`,
        uid: true
      }
    });
  },
  home(locale) {
    return axios.post("/api/query", {
      query: "page('home')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        text: `page.content('${locale}').home.kirbytext`
      }
    });
  },
  festival(locale) {
    return axios.post("/api/query", {
      query: "page('festival')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        text: `page.content('${locale}').festival.kirbytext`
      }
    });
  },
  podcast(locale) {
    return axios.post("/api/query", {
      query: "page('podcasts')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        years: {
          query: "page.children.listed",
          select: {
            title: "page.title",
            uid: true,
            text: "page.text.kirbytext",
            episodes: {
              query: "page.podcasts.toStructure",
              select: {
                embed: "structureItem.embed"
              }
            }
          }
        }
      }
    });
  },
  testimonials(locale) {
    return axios.post("/api/query", {
      query: "page('testimonials')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        children: {
          query: "page.testimonials.toStructure",
          select: {
            quote: `structureItem.content('${locale}').quote`,
            name: `structureItem.content('${locale}').name`
          }
        }
      }
    });
  },
  gallery(locale) {
    return axios.post("/api/query", {
      query: "page('gallery')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        children: {
          query: "page.children.listed",
          select: {
            title: `page.content('${locale}').title`,
            uid: "page.uid",
            images: {
              query: "page.images",
              select: {
                url: "file.url",
                small: "file.resize(400).url",
                srcset: "file.srcset([400, 800, 1200, 1600, 2000])",
                caption: "file.caption.kirbytext"
              }
            }
          }
        }
      }
    });
  },
  program(locale) {
    return axios.post("/api/query", {
      query: "page('program')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        friday: `page.content('${locale}').friday.kirbytext`,
        saturday: `page.content('${locale}').saturday.kirbytext`,
        documents: {
          query: "page.documents",
          select: {
            url: "file.url",
            title: "file.caption",
            filename: "file.filename"
          }
        },
        eventsfriday: {
          query: "page.children.listed.filterBy('day', 'friday')",
          select: {
            title: `page.content('${locale}').title`,
            uid: true,
            event: "page.event",
            description: `page.content('${locale}').description.kirbytext`,
            day: "page.day",
            hour: "page.time.toDate('H')",
            minute: "page.time.toDate('i')",
            stage: "page.stage",
            cancelled: "page.cancelled.toBool",
            speaker: {
              query: `page.content('${locale}').speaker.toStructure`,
              select: {
                name: "structureItem.name",
                occupation: `structureItem.occupation`,
                bio: `structureItem.bio.kirbytext`,
                image: {
                  query: "structureItem.image.toFile",
                  select: {
                    url: "file.url"
                  }
                }
              }
            }
          }
        },
        eventssaturday: {
          query: "page.children.listed.filterBy('day', 'saturday')",
          select: {
            title: `page.content('${locale}').title`,
            uid: true,
            event: "page.event",
            description: `page.content('${locale}').description.kirbytext`,
            day: "page.day",
            hour: "page.time.toDate('H')",
            minute: "page.time.toDate('i')",
            stage: "page.stage",
            cancelled: "page.cancelled.toBool",
            speaker: {
              query: `page.content('${locale}').speaker.toStructure`,
              select: {
                name: "structureItem.name",
                occupation: `structureItem.occupation`,
                bio: `structureItem.bio.kirbytext`,
                image: {
                  query: "structureItem.image.toFile",
                  select: {
                    url: "file.url"
                  }
                }
              }
            }
          }
        }
      }
    });
  },
  partner(locale) {
    return axios.post("/api/query", {
      query: "page('partner')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        partners: {
          query: "page.partners.toStructure",
          select: {
            name: `structureItem.name`,
            link: `structureItem.link`,
            uid: "structureItem.name.slug",
            image: {
              query: "structureItem.image.toFile",
              select: {
                url: "file.url"
              }
            }
          }
        }
      }
    });
  },
  tickets(locale) {
    return axios.post("/api/query", {
      query: "page('tickets')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        tickets: "page.tickets",
        anfahrt: "page.anfahrt"
      }
    });
  },
  archive(locale) {
    return axios.post("/api/query", {
      query: "page('archive')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        items: {
          query: "page.archive.toStructure",
          select: {
            year: `structureItem.content('${locale}').year`,
            link: `structureItem.content('${locale}').link`
          }
        }
      }
    });
  },
  curators(locale) {
    return axios.post("/api/query", {
      query: "page('curators')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        peoples: {
          query: "page.curators.toStructure",
          select: {
            name: `structureItem.content('${locale}').name`,
            bio: `structureItem.content('${locale}').bio.kirbytext`,
            uid: "structureItem.name.slug",
            occupation: `structureItem.occupation`,
            image: {
              query: "structureItem.image.toFile",
              select: {
                url: "file.url"
              }
            }
          }
        }
      }
    });
  },
  press(locale) {
    return axios.post("/api/query", {
      query: "page('press')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        items: {
          query: "page.press.toStructure",
          select: {
            title: `structureItem.content('${locale}').title`,
            link: `structureItem.content('${locale}').link`
          }
        }
      }
    });
  },
  contact(locale) {
    return axios.post("/api/query", {
      query: "page('contact')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        address: "page.address.kirbytext",
        facebook: "page.facebook",
        instagram: "page.instagram"
      }
    });
  },
  support(locale) {
    return axios.post("/api/query", {
      query: "page('support')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        textarea: `page.content('${locale}').support.kirbytext`
      }
    });
  },
  organization(locale) {
    return axios.post("/api/query", {
      query: "page('organization')",
      select: {
        title: `page.content('${locale}').title`,
        uid: true,
        organizers: {
          query: "page.organization.toStructure",
          select: {
            name: `structureItem.content('${locale}').name`,
            bio: `structureItem.content('${locale}').bio.kirbytext`,
            email: `structureItem.email`,
            uid: "structureItem.name.slug",
            image: {
              query: "structureItem.image.toFile",
              select: {
                url: "file.url"
              }
            }
          }
        }
      }
    });
  }
};
